/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types',
	'ca-ui-toolkit',
	'require'
], function(React, PropTypes, UI_TOOLKIT, require) {

	const Button = UI_TOOLKIT.Button;
	class ButtonReact extends React.Component {
		constructor(props){
			super(props);
			this.itemSpec = this.props.itemSpec;
			this.myRef = React.createRef();
			this.requireFn = props.requireFn || require;
			this.state = this.props.itemSpec;
			this._isMounted = false;
		}

		_buttonSelected(evt) {
			if (this.state.update) {
				this.props.updateButton();
			}
			if (typeof this.state.selected !== 'undefined') {
				this.setState({
					selected: !this.itemSpec.selected
				});
				this.props.updateButton();
			}

			if (this.state.type === 'NextView') {
				this.props.nextViewCb(this.state, evt, this.props.updateButton);
			} else {
				if (this.state.actions) {
					this.state.actions.apply.apply(this, arguments);
				} else if (this.itemSpec.action) {
					this.state.action.apply(this, arguments);
				}
			}
		}

		_handleClick(evt) {
			this._buttonSelected(evt);
		}

		_handleKeyDown = (evt) => {
			if(evt.keyCode === 32 || evt.keyCode === 13) {
				this._buttonSelected(evt);
			}
		}

		_renderCoachMark() {
			if(!this.state.coachMark || !this.state.coachMark.dashboard) {
				return;
			}

			const dashboard = this.state.coachMark.dashboard;
			const coachMark = dashboard.getFeature('CoachMark');
			if (!coachMark) {
				return;
			}

			const coachMarkOptions = {
				id: this.state.coachMark.id,
				title: this.state.coachMark.title,
				contents: this.state.coachMark.contents,
				placement: 'bottom',
				domElement: this.myRef.current._node
			};
			dashboard.prepareGlassOptions(coachMarkOptions);
			coachMark.addCoachMark(coachMarkOptions);
		}

		_renderDecorator() {
			if (this.state.decoratorView) {
				const decoratorView = this.state.decoratorView;
				this.requireFn([decoratorView.viewModule], (ViewModule) => {
					if (this._isMounted) {
						try {
							let viewOptions = typeof decoratorView.viewOptions === 'function' ? decoratorView.viewOptions() : decoratorView.viewOptions;
							viewOptions = viewOptions || {};
							viewOptions.containerNode = this.myRef.current._node;
							this._decorator = new ViewModule(viewOptions);
							this._decorator.render();
						} catch (err) {
							console.error(err); // livewidget-cleanup
						}
					}
				});
			}
		}

		_removeDecorator() {
			if (this._decorator) {
				this._decorator.remove();
				this._decorator = null;
			}
		}

		componentDidMount() {
			this._isMounted = true;
			if(this.state.callbacks) {
				this.state.callbacks.registerCallback(this);
			}
			try {
				this._renderCoachMark();
				this._renderDecorator();
			} catch(err) {
				console.error(err); // livewidget-cleanup
			}
		}

		componentWillUnmount() {
			this._isMounted = false;
			if(this.state.callbacks) {
				this.state.callbacks.unregisterCallback();
			}
			this._removeDecorator();
		}

		updateState(spec) {
			this.setState(spec);
		}

		_getButtonClass() {
			let classList = [];
			if(this.state.selected) {
				classList.push('selected');
			}
			if(this.state.className) {
				classList.push(this.state.className);
			}
			return classList.join(' ');
		}

		render() {
			const isButtonDisabled = () => {
				if (!this.state.disabled) {
					return false;
				} else {
					return (typeof this.state.disabled === 'function') ? this.state.disabled() : true;
				}
			};
			const buttonClass = this._getButtonClass();
			return (
				<Button
					appcues-data-id={this.state.name}
					ref={this.myRef}
					key={this.state.name}
					title={this.state.label}
					label={!this.props.toolbarOptions || !this.props.toolbarOptions.iconOnly ? this.state.text : undefined}
					iconSize="small"
					variant="icon"
					intent="primary"
					autofocus={this.state.focus}
					ellipsis={true}
					disabled={isButtonDisabled()}
					iconLeft={!this.props.toolbarOptions || !this.props.toolbarOptions.textOnly ? this.state.icon  : undefined}
					aria-label={this.state.label}
					className={buttonClass}
					onClick={(evt) => this._handleClick(evt)}
					onKeyDown={(evt) => this._handleKeyDown(evt)}
				/>
			);
		}
	}

	ButtonReact.propTypes = {
		itemSpec: PropTypes.array,
		icon: PropTypes.string,
		focus: PropTypes.boolean,
		updateButton: PropTypes.function,
		nextViewCb: PropTypes.function,
		requireFn: PropTypes.function,
		toolbarOptions: PropTypes.object
	};

	return ButtonReact;
});
